import { useContext, useEffect, useRef } from "react";
import { Context } from "../../context/Context";
import EquipmentButtonIcons from "../../constants/EquipmentButtonIcon";
import "./EquipmentButtonIconModal.css";
import { UpdateEquipmentButton } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";

const EquipmentButtonIconModal = () => {
  const {
    setEquipmentButtonIconModal,
    editEquipmentButton,
    setUpdate,
    update,
    setIsLoading,
    equipmentButtons,
    setEquipmentButtons,
  } = useContext(Context);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setEquipmentButtonIconModal(modalName);
  }, []);

  const handleChangeButtonIcon = (iconId) => {
    setIsLoading(true);
    UpdateEquipmentButton({
      equipment_button_id: editEquipmentButton.id,
      name: `${editEquipmentButton.name}`,
      digit: editEquipmentButton.digit ?? 0,
      data: editEquipmentButton.data,
      icon: iconId,
      is_continual: editEquipmentButton.is_continual,
    })
      .then((res) => {
        if (res.status == 200) {
          SuccessToast("آیکون با موفقیت تغییر یافت");
          const index = equipmentButtons.findIndex(
            (item) => item.id === editEquipmentButton.id,
          );

          if (index !== -1) {
            const updatedButtons = [...equipmentButtons];
            updatedButtons[index] = {
              ...updatedButtons[index],
              icon: iconId,
            };

            setEquipmentButtons(updatedButtons);
          }
          closeButton.current.click();
          setUpdate(!update);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderEquipmentButtonIcons = () => {
    return EquipmentButtonIcons.map((icon, index) => {
      if (icon.id <= 32)
        return (
          <div key={index} onClick={() => handleChangeButtonIcon(icon.id)}>
            <img src={icon.path} alt={`Icon ${index}`} />
          </div>
        );
    });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="equipmentIconModal"
      tabIndex="-1"
      aria-labelledby="equipmentIconModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="backupModalLable">
              انتخاب آیکون
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="icon-images d-flex justify-content-around flex-wrap">
              {renderEquipmentButtonIcons()}
            </div>
          </div>
          {/* <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-success-app"
              data-bs-dismiss="modal"
              ref={closeButton}
            >
              انصراف
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default EquipmentButtonIconModal;
